import React from 'react';

import BackButton from '../../../components/BackButton/BackButton';
import AppButton from '../../../components/Button/AppButton/AppButton';
import {ArticlePageLayout} from '../../../components/DataDisplay';
import ComputerIcon from '../../../components/Icons/ComputerIcon';
import Container from '../../../components/Layout/Container/Container';
import PopupFullPage from '../../../components/Popup/PopupFullPage';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import appRouterService from '../../../services/route/appRouterService';
import {hideModalAction} from '../../../state/ducks/modal';
import {dispatch} from '../../../state/store';

const UsbRequiredPopup = ({modalType, deviceName = ''}) => {
    const localizedStrings = getLocalizedStrings();
    const titleText = localizedStrings.formatString(
        localizedStrings[localizationKeys.USB_REQUIRED_POPUP_TITLE_TEXT],
        deviceName
    );

    const onClick = () => {
        appRouterService.forwardToSelectDevice();
        dispatch(hideModalAction(modalType));
    };

    return (
        <PopupFullPage>
            <Container isFloatHeight className='min-h-[48px] w-full'>
                <BackButton
                    onClick={onClick}
                    className='absolute left-8 top-[50%] -translate-y-1/2 rtl:left-[unset] rtl:right-8'
                    ariaLabel={localizedStrings[localizationKeys.USB_REQUIRED_POPUP_BACK_TO_SELECT_DEVICE_ARIA_LABEL]}
                />
            </Container>
            <ArticlePageLayout
                icon={<ComputerIcon className='mb-4 md:h-16 md:w-16' />}
                titleText={titleText}
                descriptionKey={localizationKeys.USB_REQUIRED_POPUP_DESCRIPTION_TEXT}
            >
                <AppButton className='mt-12' tertiary onClick={onClick}>
                    {localizedStrings[localizationKeys.USB_REQUIRED_POPUP_BUTTON_TEXT]}
                </AppButton>
            </ArticlePageLayout>
        </PopupFullPage>
    );
};

export default UsbRequiredPopup;
